module.exports = __webpack_public_path__ + "static/media/ipod_touch_dark.68a51910.svg";